import { Button } from "react-bootstrap";
import '../../css/buttonComponent.css';
import { useState } from "react";

const ButtonComponent = ({
  onButtonClick,
  tag = 'Submit',
  disabled = false,
  color,
  border,
  background,
  disabledColor,
  disabledBorder,
  disabledBackground,
  width = '96px',
}) => {

  const defaultStyle = {color: color, border: border, background: background, width: width, minWidth: width };
  const disabledStyle = {color: disabledColor, border: disabledBorder, background: disabledBackground, width: width, minWidth: width};

  const [style, setStyle] = useState(defaultStyle);

  
  return (
    <>
      <Button disabled={disabled} className="default-style" style={disabled ? disabledStyle :  style} 
      onClick={() => { onButtonClick && onButtonClick() }}
      onMouseEnter={() => {(!disabled) && setStyle(defaultStyle) }}
      onMouseLeave={() => {(!disabled) && setStyle(defaultStyle) }}
      onMouseDown={() => {(!disabled) && setStyle(defaultStyle) }}
      onMouseUp={() => {(!disabled) && setStyle(defaultStyle) }}
        ><div>{tag}</div></Button>
    </>
  );
};

export default ButtonComponent;
